/**
 * Canonical home for all BZE message context types and factory functions.
 * Add new contexts here, not types.ts.
 */

import { CrmObjectContextTypename, DeviceContextTypename, TimeZoneContextTypename, InteractiveModeContextTypename, PageContextTypename, AppSearchScopeContextTypename, ToolSetCustomizationsContextTypename, SkillsContextTypename, ViewedArtifactContextTypename, BreezeAssistantTrackingContextTypename, SubagentConfigContextTypename, ModelOverrideContextTypename } from '../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineStreamingService';
export function createCrmObjectContext(fields) {
  return Object.assign({}, fields, {
    __typename: CrmObjectContextTypename
  });
}
export function createDeviceContext(fields) {
  return Object.assign({}, fields, {
    __typename: DeviceContextTypename
  });
}
export function createTimeZoneContext(fields) {
  return Object.assign({}, fields, {
    __typename: TimeZoneContextTypename
  });
}
export function createInteractiveModeContext(fields) {
  return Object.assign({}, fields, {
    __typename: InteractiveModeContextTypename
  });
}
export function createPageContext(fields) {
  return Object.assign({}, fields, {
    __typename: PageContextTypename
  });
}
export function createAppSearchScopeContext(fields) {
  return Object.assign({}, fields, {
    __typename: AppSearchScopeContextTypename
  });
}
export function createToolSetCustomizationsContext(fields) {
  return Object.assign({}, fields, {
    __typename: ToolSetCustomizationsContextTypename
  });
}
export function createSkillsContext(fields) {
  return Object.assign({}, fields, {
    __typename: SkillsContextTypename
  });
}
export function createViewedArtifactContext(fields) {
  return Object.assign({}, fields, {
    __typename: ViewedArtifactContextTypename
  });
}
export function createBreezeAssistantTrackingContext(fields) {
  return Object.assign({}, fields, {
    __typename: BreezeAssistantTrackingContextTypename
  });
}
export function createSubagentConfigContext(subagents) {
  return {
    subagents,
    __typename: SubagentConfigContextTypename
  };
}

/**
 * Pins model, reasoning effort and priority tier for one turn. Internal callers only — the server
 * rejects the request outright when the caller is not internal or a value is invalid.
 */
export function createModelOverrideContext(fields) {
  return Object.assign({}, fields, {
    __typename: ModelOverrideContextTypename
  });
}